import { css } from 'styled-components';

export const DSStyles = css``;
